module.exports = __webpack_public_path__ + "static/media/logo-parceiro-europa.b6a84927.jpg";